import { requireNativeComponent } from 'react-native';

// The native module is registered as "PersonaInquiryView" (without Manager suffix)
export const PersonaInquiryViewManager: any =
  requireNativeComponent('PersonaInquiryView');
